import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const store = useStore()
const membership = store.getters.membership // 会员信息
const syncOrderVisible = ref(false)
const open = () => {
  syncOrderVisible.value = true
}

const closeModal = () => {
  syncOrderVisible.value = false
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: syncOrderVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((syncOrderVisible).value = $event)),
      width: "500px",
      center: "",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "custom-class": "syncOrderVisible",
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: closeModal,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('提示')), 1),
          _createElementVNode("span", {
            innerHTML: _unref(t)('尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）')
        .replace('T',`<span style='color:#eb4545'>${_unref(membership).updateTime}</span>`)
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})